export const ADMIN_AUTH_COOKIE_DAYS = 15;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const adminAuthCookieOptions = ({ rememberMe = false } = {}) => {
  const options = {
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax",
  };

  if (rememberMe) {
    options.expires = new Date(Date.now() + ADMIN_AUTH_COOKIE_DAYS * MS_PER_DAY);
  }

  return options;
};
